import { defineStore } from 'pinia';
import { useApiStore } from './API.module';

export const useProfilesStore = defineStore('profiles', {
  state: () => ({
    items: [],
    page: 0,
    done: false,
    total: null,
  }),
  actions: {
    async getCount(filter) {
      const { total } = await useApiStore().send({
        method: 'post',
        requestURL: '/profiles/count',
        requestData: filter,
      });
      this.total = total;
    },
    async getList(filter) {
      try {
        const response = await useApiStore().send({
          method: 'post',
          requestURL: '/profiles',
          requestData: {
            ...filter,
            skip: this.page
          }
        });
        this.items = this.items.concat(response);
        this.page += filter.rows;
        if (response.length < filter.rows) {
          this.done = true;
        }
      } catch {
        this.done = true;
      }
    },
    init() {
      this.items = [];
      this.page = 0;
      this.done = false;
      this.total = null;
    }
  }
});
